/**
 * External dependencies
 */
import React from 'react';
import classNames from 'classnames';

/**
 * Internal dependencies
 */

/**
 * Style dependencies
 */
import './styles.scss';

const InvoiceStatus = ({ status }) => {

    const classes = classNames('invoice-status', "invoice-status--" + status);

    return (
        <div className={classes}>
            <span>{status.replace('_',' ')}</span>
        </div>
    );

};

InvoiceStatus.defaultProps = {};
InvoiceStatus.propTypes = {};

export default InvoiceStatus;
